import validate from "C:/git/order-app-2/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45cart_45init_45global from "C:/git/order-app-2/middleware/01.cart-init.global.ts";
import manifest_45route_45rule from "C:/git/order-app-2/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _01_45cart_45init_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "require-auth": () => import("C:/git/order-app-2/middleware/require-auth.ts"),
  "require-partner-customer-select": () => import("C:/git/order-app-2/middleware/require-partner-customer-select.ts"),
  "require-partner": () => import("C:/git/order-app-2/middleware/require-partner.ts"),
  "require-sms-verified": () => import("C:/git/order-app-2/middleware/require-sms-verified.ts")
}